function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.toLocaleDateString(
    'nl-NL',
    { day: '2-digit', month: '2-digit', year: 'numeric' }
  )}`;
}
  
function formatDateToTime(dateString) {
  const date = new Date(dateString);
  return `${date.toLocaleTimeString(
    'en-US',
    { hour: '2-digit', minute: '2-digit', hour12: false }
  )}`
}

function formatTime(dateString) {
  const date = new Date(`1970-01-01T${dateString}`);
  return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
}

export { formatDate, formatDateToTime, formatTime };